export enum RequestErrorHandler {
  None = 0,
  Snackbar = 1,
  Dialog = 2
}
